import type { OrganizationRole } from "@/types/organization.type";

/** The product calls a Guest a client (Figma 09). */
export function roleLabel(role: OrganizationRole | string): string {
  return role === "Guest" ? "Client" : role;
}

/** What a role can do, as a teammate reads it ("Can" on People). */
export function roleCan(role: OrganizationRole | string, brandCount: number): string {
  const all = brandCount === 1 ? "the 1 brand" : `all ${brandCount} brands`;
  switch (role) {
    case "Owner":
      return "Everything, including people, accounts and the plan";
    case "Contributor":
      return `Plans, writes and schedules posts in ${all}`;
    case "Viewer":
      return `Sees ${all} and comments. Changes nothing.`;
    default:
      return "Sees only the brands picked for them, for review";
  }
}

/** The same, said to the person themselves ("You would be" / "Your role"). */
export function roleForYou(role: OrganizationRole | string): string {
  switch (role) {
    case "Owner":
      return "Owner: everything, including people, accounts and the plan";
    case "Contributor":
      return "Contributor: you plan, write and schedule posts in every brand";
    case "Viewer":
      return "A Viewer: you see every brand and comment, and change nothing";
    default:
      return "A client: you review the brands you were given and comment";
  }
}

export const takesSeat = (role: OrganizationRole | string) => role !== "Guest";
